<template>
  <div v-if="useIntents" class="cp__order__item__inputs">
    <SelectItemIntents :session="session" :item="item" :intents="intents" :use-intents="true" @select="selectIntent"></SelectItemIntents>
  </div>
  <div v-else-if="hasIntents" class="cp__order__item__inputs">
    <b-button
      :class="{
        'item-select-btn': true,
        'btn-outline-success': hasPrimaryIntent,
        'no-outline-btn': !hasPrimaryIntent,
        'position-relative': true
      }"
      class="item-select-btn no-outline-btn position-relative"
      variant="secondary"
      @click="select($event)"
    >
      <span class="flex-1 mr-1">{{itemSelectLabel}}</span>
      <font-awesome-icon class="position-absolute" :icon="['fas', 'angle-right']"></font-awesome-icon>
    </b-button>
    <SelectItemIntents :session="session" :item="item" :intents="intents" :use-intents="false" @select="selectIntent"></SelectItemIntents>
  </div>
  <b-button v-else block class="item-select-btn no-outline-btn position-relative" @click="select($event)">
    <span v-show="selected">Selected!</span>
    <template v-show="!selected">
      <span class="flex-1 mr-1">{{itemSelectLabel}}</span>
      <font-awesome-icon class="position-absolute" :icon="['fas', 'angle-right']"></font-awesome-icon>
    </template>
  </b-button>
</template>

<script>
import {isPrimaryIntent} from '@/utils'
const SelectItemIntents = () => import('./SelectItemIntents')

export default {
  name: 'SelectItemButtons',
  components: {SelectItemIntents},
  props: {
    session: Object,
    item: Object,
    selected: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    subscription: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    useIntents: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    intents: {
      type: Array,
      default: function() {
        return []
      }
    },
    itemSelectLabel: {
      type: String,
      default: function() {
        return 'Select'
      }
    }
  },
  data: function() {
    return {
      showAllIntents: false
    }
  },
  computed: {
    hasIntents: function() {
      return this.intents && this.intents.length
    },
    hasPrimaryIntent: function() {
      return this.hasIntents && this.intents.some((intent) => isPrimaryIntent(intent))
    }
  },
  methods: {
    select: function(event) {
      event.stopPropagation()
      this.$emit('select')
    },
    selectIntent: function(intent) {
      this.$emit('select', intent)
    },
    viewSubscriptionOrders: function(event) {
      event.stopPropagation()
      this.$emit('viewSubscriptionOrders')
    }
  }
}
</script>

<style scoped>
.cp__order__item__inputs, .cp__order__item__inputs > div {
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

</style>
